import styled from "styled-components";

export const HeroTitle = styled.div`
    background-color: rgba(5, 103, 49, 0.3);
    text-align: center;
    padding: 60px 0px;
    h1{
        color: #056731;
        font-size: 50px;
        margin: 0;
    }
    h4{
        font-size: 30px;
        font-weight: 400;
        margin: 0;
        color: #056731;
    }
    @media screen and (max-width: 480px) {
        padding: 20px 0px;
        h1{
            font-size: 30px;
            margin-top: 30px;
        }
        h4{
            font-size: 20px;
        }
    } 
`
export const ContentKits = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 60px;
    gap: 15px;
    @media screen and (max-width: 480px) {
        overflow: auto;
        justify-content: flex-start;
        padding: 20px 0px;
    } 
`
export const BackButton = styled.button`
    background-color: #ffffff;
    border: 1px solid #056731;
    color: #056731;
    padding: 8px 16px;
    border-radius: 4px;
    font-size: 16px;
    position: absolute;
    left: 30px;
    top: -20px;
    @media screen and (max-width: 480px) {
        top: -40px;
        left: 10px;
    } 
`